<template>
    <div class="ask-answer-log-wrapper scroll-tracker">
        <div class="ask-answer-panel">
            <div class="ask-log-title">{{ title }}</div>
            <div class="data-panel-content">
                <LogOperationBar
                    class="log-content-opeat"
                    @updateTime="updateTime"
                    @updateLogData="updateLogData"
                    @updateSearchType="updateSearchType"
                />
                <div class="table-top-message">
                    <RoundButton @btnClick="exportHandler" :text="exportLabel"></RoundButton>
                    <div class="show-total">
                        {{ $t("zhiji.robotLog.askTotal") }}<span class="log-num">{{ withoutFirstAnswerTotal }}</span>
                    </div>
                </div>
                <Table class="log-table-list" :config="tableConfig" :dataset="tableData" @columnClick="tableColumnClick" />
            </div>
        </div>
        <div class="page-control" v-show="logTotal >= 10">
            <PageControl :total="logTotal" :curPage="curPage" :lengthRank="pageLengthRank" :pageLength="10" @pageClick="pageChange" />
        </div>
    </div>
</template>

<script>
import LogOperationBar from "./components/LogOperationBar";
import RoundButton from "@/views/zhiji/bComponents/buttons/RoundButton";
import Table from "@/views/zhiji/bComponents/table/Table";
import PageControl from "@/views/zhiji/bComponents/pageController/PageControl";
import ChatDetailModal from "./components/ChatDetailModal";
import { askLogTable } from "./askAnswerLogConfig.js";
import { URLs } from "@/views/zhiji/js/common/constants.js";

export default {
    name: "AskAnswerLogPage",
    components: {
        LogOperationBar,
        Table,
        RoundButton,
        PageControl
    },
    data() {
        return {
            curPage: 1,
            curPageLen: 10,
            pageLengthRank: 10,
            logData: {
                tableData: [],
                count: 0,
                userCount: 0,
                inputCount: 0,
                clickCount: 0
            },
            reqData: {},
            startTime: this.zhiji.dateFormat(new Date(), "YYYY-MM-DD 00:00"),
            endTime: this.zhiji.dateFormat(new Date()),
            searchType: "all"
        };
    },
    computed: {
        title() {
            return this.$t("zhiji.robotLog.askAnswerLog");
        },
        exportLabel() {
            return this.$t("zhiji.common.export");
        },
        tableConfig() {
            return askLogTable();
        },
        tableData() {
            return this.logData.tableData;
        },
        logTotal() {
            return parseInt(this.logData.count);
        },
        withoutFirstAnswerTotal() {
            return this.logData.userCount;
        },
        handQuestionTotal() {
            return this.logData.inputCount;
        },
        clickQuestionTotal() {
            return this.logData.clickCount;
        }
    },
    watch: {
        exportLabel() {
            this.getAskLogData();
        }
    },
    mounted() {
        this.getAskLogData();
    },
    methods: {
        getAskLogData() {
            let reqData = {
                startDate: this.startTime,
                endDate: this.endTime,
                curPage: this.curPage,
                size: this.curPageLen,
                searchType: this.searchType
            };
            this.reqData = reqData;
            this.getRespLogData(reqData);
        },
        getRespLogData(reqData) {
            this.zhiji.requestByServiceName("queryAskAnswerLog", reqData).then(result => {
                this.logData.count = result.count;
                this.logData.userCount = result.userCount;
                this.logData.inputCount = result.inputCount;
                this.logData.clickCount = result.clickCount;
                this.logData.tableData.splice(0, this.logData.tableData.length, ...result.tableData);
            });
        },
        tableColumnClick(data) {
            if (data.colId == "operate") {
                this.$store.dispatch("zhiji/showModal", {
                    type: ChatDetailModal,
                    data: {
                        userId: data.rowData.addData.userId,
                        answerDetail: data.rowData.addData.answerDetail,
                        enAnswerDetail: data.rowData.addData.enAnswerDetail,
                        lang: data.rowData.addData.lang,
                        startDate: this.startTime,
                        endDate: this.endTime
                    }
                });
            }
        },
        exportHandler() {
            const searchObj = { all: "", user: "user_id", scenes: "set_id", stand: "question", questionId: "question_id", chatId: "session_id" };
            const wordsObj = { all: "", yes: "1", no: "0" };
            const channelObj = { all: "", SDKLogin: "sdk_login", SDKSet: "sdk", H5Scenes: "h5_block", H5Site: "h5_safety" };
            const questionObj = { all: "", initQues: "first_ask", input: "input", click: "click" };
            let reqUrl = `https:` + URLs.EXPORT_ASK_ANSWER_LOG + `?start_time=${this.startTime}&end_time=${this.endTime}`;
            let reqUrlParam = `&channel=${channelObj[this.reqData.channel] || ""}
                &question_type=${questionObj[this.reqData.questionType] || ""}
                &answer_type=${this.reqData.answerType || ""}
                &search_type=${searchObj[this.searchType]}
                &keyword=${this.reqData.keyWord || ""}
                &download_type=excel
                &sensitive_words=${wordsObj[this.reqData.senWords] || ""}
                &language=${this.reqData.lang || ""}`;

            reqUrlParam = reqUrlParam.replace(/\s+/g, "");
            reqUrl = reqUrl + reqUrlParam;

            this.zhiji.requestByServiceName("getDownloadToken", reqUrl).then(result => {
                window.open(result, "_blank");
            });
        },
        updateSearchType(data) {
            this.searchType = data;
        },
        updateLogData(data) {
            this.reqData = data;
            this.curPage = data.curPage;
            this.curPageLen = data.curPageLen;
            let timeDiffer = new Date(this.reqData.endDate) - new Date(this.reqData.startDate);

            timeDiffer > 0 && this.getRespLogData(this.reqData);
        },
        pageChange(data) {
            if (this.curPageLen == data.pageLength && this.curPage == data.curPage) {
                return;
            }
            this.curPageLen = data.pageLength;
            this.curPage = data.curPage;
            this.reqData.curPage = data.curPage;
            this.reqData.curPageLen = data.pageLength;

            this.getRespLogData(this.reqData);
        },
        updateTime(date) {
            date.type == "start" ? (this.startTime = date.value) : (this.endTime = date.value);
        }
    }
};
</script>

<style lang="scss" scoped>
.ask-answer-log-wrapper {
    height: 100%;
    padding: 16px 16px 16px 16px;
    background: #f2f7fb;
    overflow-y: auto;
    box-sizing: border-box;

    .ask-answer-panel {
        padding: 0 24px 24px 24px;
        background: #ffffff;
        border: 1px solid #d9e4ef;
        border-radius: 4px;

        .ask-log-title {
            padding: 16px 0 20px;
            font-size: 14px;
            color: #41475e;
            line-height: 20px;
            font-weight: bold;
            border-bottom: 1px solid #e1eaf2;
        }

        .table-top-message {
            padding: 8px 20px;
            background: #f2f7fb;
            border-width: 1px 1px 0 1px;
            border-style: solid;
            border-color: #e3ecf5;
            display: flex;

            .show-total {
                height: 32px;
                line-height: 32px;
                margin-left: 42px;

                .log-num {
                    color: #00c972;
                    margin-right: 50px;
                }
            }
        }

        .log-table-list {
            border-width: 0 1px 1px 1px;
            border-style: solid;
            border-color: #e3ecf5;
            box-sizing: border-box;
        }
    }

    .page-control {
        width: 100%;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px 0;
        text-align: center;
        color: rgba(65, 71, 94, 0.7);
    }
}
</style>
